import { programDetailsConfig, DetailType } from "../../../../constants";
import { HTMLTagRegEx } from "../../../../../../constants";
import { TValidator } from "../../../../../wizard/types";

type CommonObject = { [key: string]: any };

const requiredTypes: DetailType[] = programDetailsConfig
  .filter((config) => config.isRequired)
  .map((config) => config.type);

const validator: TValidator = async ({ values, activeStepName }) => {
  const errors: CommonObject = {
    details: {},
  };

  const details = values[activeStepName]?.details || {};

  requiredTypes.forEach((type) => {
    if (
      !details[`type_${type}`] ||
      !details[`type_${type}`].replace(HTMLTagRegEx, "").trim().length
    ) {
      errors.details[`type_${type}`] = "This field is required.";
    }
  });

  if (Object.keys(errors.details).length > 0) {
    throw {
      [activeStepName]: errors,
    };
  }
};

export default validator;
